

























































































































// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { POSContact } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Avatar from '@shared/components/avatar/avatar.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faMapMarker, faBirthdayCake, faHashtag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faMapMarker, faBirthdayCake, faHashtag);

@Component({
  name: 'bpc-pos-contact-summary',
  components: {
    FontAwesomeIcon,
    'bpc-avatar': Avatar,
  },
})
export default class PosContact extends Vue {
  // PROPS
  @Prop({ type: Object }) readonly contact: POSContact;
  @Prop({ type: Boolean }) readonly extended: boolean;
  @Prop({ type: Boolean, default: true }) readonly showActions: boolean;
  @Prop({ type: Boolean, default: false }) readonly showDownloadCard: boolean;

  seeMoreClicked() {
    this.$emit('see-more-clicked');
  }
  addBadgeClicked() {
    this.$emit('add-badge-clicked');
  }

  seeBadgeClicked() {
    this.$emit('see-badge-clicked');
  }

  async downloadCard(id: number | string) {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('contact');
    const relativePath = '/download-card/' + id;
    this.$bpcApi.postDownload(`${basePath + relativePath}`, '').subscribe();
  }

  get activeAccessControlModule(): boolean {
    return this.$modulesService.hasModuleActivated('access_control');
  }

  get contactPhotoUrl() {
    console.log(this.contact.photo_url);
    // return 'https://w7.pngwing.com/pngs/129/292/png-transparent-female-avatar-girl-face-woman-user-flat-classy-users-icon.png';
    return this.contact.photo_url;
  }

  get contactHasBadge() {
    return this.contact.primaryBadgeNumber !== null;
  }

  currentImgField = 'defaultConversionUrl';
  imgFail = false;

  onImgError() {
    if (this.currentImgField === 'url') {
      this.imgFail = true;
    }
    if (this.currentImgField === 'defaultConversionUrl') {
      this.currentImgField = 'url';
    }
  }

  formatDate(value: string) {
    return this.$bpcHelper.formatDate(value);
  }
}
